export enum QuestionType {
  OPTION = 'option',
  TEXT = 'text'
}
